import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gantanhao",
  "use": "icon-gantanhao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-gantanhao\"><path d=\"M512 23.273a93.09 93.09 0 0 1 93.09 93.09v465.455a93.09 93.09 0 1 1-186.18 0V116.364A93.09 93.09 0 0 1 512 23.273zM512 768a93.09 93.09 0 0 1 93.09 93.09v46.546a93.09 93.09 0 1 1-186.18 0v-46.545A93.09 93.09 0 0 1 512 768z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/gantanhao.svg
// module id = HwKc
// module chunks = 12